(function () {
  var scrollLockY = 0;
  var scrollLocked = false;

  function getDrawer() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer || !drawer.classList.contains("cb-cart-drawer--pro")) return null;
    return drawer;
  }

  function setDrawerHeaderCount(count) {
    var badge = document.querySelector("#CartDrawer [data-cart-drawer-count]");
    if (!badge || count == null || count === "") return;
    badge.textContent = String(count);
  }

  function syncDrawerCountFromDom() {
    var items = document.querySelector("#CartDrawer [data-products] .cart__items");
    if (!items || items.dataset.count == null || items.dataset.count === "") return;
    setDrawerHeaderCount(items.dataset.count);
  }

  function syncDrawerCountFromApi() {
    var url =
      (window.theme && theme.routes && theme.routes.cart) || "/cart.js";
    return fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart && cart.item_count != null) {
          setDrawerHeaderCount(cart.item_count);
        }
        return cart;
      })
      .catch(function () {});
  }

  function initCartItemsCountObserver() {
    var products = document.querySelector("#CartDrawer [data-products]");
    if (!products || products.dataset.cbCountObs) return;
    products.dataset.cbCountObs = "1";

    var observer = new MutationObserver(function () {
      syncDrawerCountFromDom();
    });
    observer.observe(products, { childList: true, subtree: true });
  }

  function isCartDrawerOpen() {
    var drawer = document.getElementById("CartDrawer");
    return (
      drawer &&
      drawer.classList.contains("drawer--is-open") &&
      document.documentElement.classList.contains("js-drawer-open")
    );
  }

  function lockPageScroll() {
    if (scrollLocked || !isCartDrawerOpen()) return;
    scrollLocked = true;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("cb-cart-scroll-lock");
    document.body.classList.add("cb-cart-scroll-lock");
    document.body.style.top = "-" + scrollLockY + "px";
  }

  function unlockPageScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.documentElement.classList.remove("cb-cart-scroll-lock");
    document.body.classList.remove("cb-cart-scroll-lock");
    document.body.style.top = "";
    window.scrollTo(0, scrollLockY);
  }

  function initCartDrawerScrollLock() {
    if (window.__cbCartScrollLockBound) return;
    window.__cbCartScrollLockBound = true;

    document.addEventListener("drawerOpen.CartDrawer", function () {
      window.setTimeout(lockPageScroll, 0);
      syncDrawerCountFromApi();
    });

    var htmlObserver = new MutationObserver(function () {
      if (scrollLocked && !document.documentElement.classList.contains("js-drawer-open")) {
        unlockPageScroll();
      } else if (!scrollLocked && isCartDrawerOpen()) {
        lockPageScroll();
      }
    });
    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function initCartDrawerPro() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll("[data-cb-cart-toggle]").forEach(function (btn) {
      if (btn.dataset.cbCartToggleBound) return;
      btn.dataset.cbCartToggleBound = "1";
      btn.addEventListener("click", function () {
        var panelId = btn.getAttribute("aria-controls");
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        var expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", expanded ? "false" : "true");
        panel.hidden = expanded;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCartDrawerScrollLock();
    initCartItemsCountObserver();
    initCartDrawerPro();
    syncDrawerCountFromDom();
  });

  document.addEventListener("ajaxProduct:added", function () {
    syncDrawerCountFromApi();
  });

  document.addEventListener("cart:updated", function (evt) {
    initCartDrawerPro();
    var count = evt.detail && evt.detail.cart && evt.detail.cart.item_count;
    if (count != null) {
      setDrawerHeaderCount(count);
    }
  });

  document.addEventListener("cart:build", function () {
    initCartDrawerPro();
  });
})();
